import { css } from '@emotion/css';

export const containerStyles = css`
  justify-content: start !important;
`;
